import { createTheme } from "@mui/material/styles";

// Luna 品牌色板：深墨蓝做操作台底色，黄铜色做强调——
// 呼应"音响设备/调音台"的实体质感，避开默认 MUI 蓝与生成式设计常见的
// 暖米色+赤陶色组合。
export const ink = "#1B1E27";
export const inkText = "#F5F3EE";
export const paper = "#FAFAF8";
export const line = "#E4E1DA";

const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: paper,
      paper: "#FFFFFF",
    },
    primary: {
      light: "#D9A53D", // 深色底（如顶部导航）上使用
      main: "#9C6B12", // 浅色底上使用，对比度达 AA
      dark: "#7A5410",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#B3392A",
    },
    text: {
      primary: "#1F2126",
      secondary: "#63676F",
    },
    divider: line,
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
    h3: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 600, letterSpacing: "-0.02em" },
    h4: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 600, letterSpacing: "-0.01em" },
    h5: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 600, letterSpacing: "-0.01em" },
    h6: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 600, letterSpacing: "-0.005em" },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: ink,
          color: inkText,
          boxShadow: "none",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          border: `1px solid ${line}`,
          borderRadius: 10,
          backgroundImage: "none",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
  },
});

export default theme;
